import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as microsoftTeams from '@microsoft/teams-js';
import msal, { loginRequest } from 'lib/msal';
import sniffer from 'sniffer';
import Modal from 'containers/Modals/Modal';
import { Button, translate } from '@haldor/ui';

var AuthenticationPopup = /*#__PURE__*/function (_Component) {
  _inherits(AuthenticationPopup, _Component);

  var _super = _createSuper(AuthenticationPopup);

  function AuthenticationPopup(props) {
    var _this;

    _classCallCheck(this, AuthenticationPopup);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "runLogin", function () {
      if (microsoftTeams.app.isInitialized()) {
        localStorage.setItem('haldor-teams-auth-progress', 'login');
        microsoftTeams.authentication.authenticate({
          url: '/Auth'
        }).then(function (response) {
          localStorage.removeItem('haldor-teams-auth-progress');

          if (msal.getAllAccounts().length > 0 && response != null) {
            _this.props.onLogin(response);
          } else {
            _this.setState({
              error: _this.props.translate('Something went wrong while signing you in')
            });
          }
        })["catch"](function (error) {
          localStorage.removeItem('haldor-teams-auth-progress');

          _this.setState({
            error: error
          });
        });
      } else {
        if (sniffer.infos.isDesktop) {
          msal.loginPopup(loginRequest).then(function (response) {
            _this.props.onLogin(response);
          })["catch"](function (reason) {
            _this.setState({
              error: reason.errorMessage
            });
          });
        } else {
          msal.loginRedirect(loginRequest);
        }
      }
    });

    _this.state = {
      error: null
    };
    return _this;
  }

  _createClass(AuthenticationPopup, [{
    key: "inIframe",
    value: function inIframe() {
      try {
        return window.self !== window.top || window.navigator.userAgent.indexOf('TeamsMobile') > -1;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement(Modal, {
        isOpen: true,
        type: "small news",
        overridePrompt: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "form",
        style: {
          marginBottom: '2.5rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title"
      }, this.state.error != null ? translate('Ops, something went wrong!') : translate('Still there?')), /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '1rem 0'
        }
      }, this.state.error != null ? translate('Signing in failed. Please try again.') : translate('You have been signed out for security reasons due to inactivity.')), this.state.error != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          border: '1px solid var(--color--blue)',
          padding: '1rem',
          margin: '1rem 0'
        }
      }, this.state.error) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.runLogin
      }, translate('log-in'))))));
    }
  }]);

  return AuthenticationPopup;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(AuthenticationPopup);